const SHOW_MESSAGE = "SHOW_MESSAGE";
const DELETE_MESSAGE = "DELETE_MESSAGE";

export default {
    SHOW_MESSAGE,
    DELETE_MESSAGE
};
